import React, { useState } from 'react';
import './About.css'
import { Link } from 'react-router-dom';
const About = ({darkmodeClass}) => {

  const [activeSection, setActiveSection] = useState('');

  const handleLinkClick = (sectionClass) => {
    setActiveSection(sectionClass);


    const sectionElement = document.querySelector(`.${sectionClass}`);
    if (sectionElement) {
      let scrollToPosition;

      // Adjust the scroll position based on screen size
      if (window.innerWidth <= 768) {
        // Small screen
        scrollToPosition = sectionElement.getBoundingClientRect().top + window.scrollY - 100;
      } else {
        // Large screen
        scrollToPosition = sectionElement.getBoundingClientRect().top + window.scrollY - 100;
      }

      // Scroll to the calculated position
      window.scrollTo({ top: scrollToPosition, behavior: 'smooth' });
    }
  };

  return (
    <div className={`about-container ${darkmodeClass}`}>
      <div className={`about-side-nav ${darkmodeClass}`}>
        <ul>
          <div className={`aboutd ${darkmodeClass}`}>
          <h1 className={`${darkmodeClass}`}>About US</h1>
          </div>
          <li><Link to="#welcome" className={`link ${activeSection  === 'welcome' ? 'active' : ''} ${darkmodeClass}`} onClick={() => handleLinkClick('welcome')}>Welcome to Pixabay</Link></li>
          <li><Link to="#vision" className={`link ${activeSection === 'vision' ? 'active' : ''} ${darkmodeClass}`} onClick={() => handleLinkClick('vision')}>Our Vision</Link></li>
          <li><Link to="#community" className={`link ${activeSection === 'community' ? 'active' : ''} ${darkmodeClass}`}  onClick={() => handleLinkClick('community')}>Community-Driven Content</Link></li>
          <li><Link to="#commitment" className={`link ${activeSection === 'commitment' ? 'active' : ''} ${darkmodeClass}`} onClick={() => handleLinkClick('commitment')}>Our Commitment</Link></li>
          <li><Link to="#explore" className={`link ${activeSection === 'explore' ? 'active' : ''} ${darkmodeClass}`} onClick={() => handleLinkClick('explore')}>Explore, Create, Share</Link></li>
          <li><Link to="#join" className={`link ${activeSection === 'join' ? 'active' : ''} ${darkmodeClass}`} onClick={() => handleLinkClick('join')}>Join the Pixabay Community</Link></li>
          <li><Link to="#thankyou" className={`link ${activeSection === 'thankyou' ? 'active' : ''} ${darkmodeClass}`} onClick={() => handleLinkClick('thankyou')}>Thank You</Link></li>
        </ul>
      </div>

      <div className={`about-page ${darkmodeClass}`}>
        <div className={`about-page-content ${darkmodeClass} ${activeSection === 'welcome' ? 'active' : ''}`}>
          <h1 className={`welcome ${darkmodeClass} ${activeSection === 'welcome' ? 'active' : ''}`}>Welcome to Pixabay</h1>
          <p>At Pixabay, we are passionate about fostering a global community of creativity and sharing. Our mission is to provide a platform where individuals from around the world can discover and share stunning, high-quality images freely.</p>
        </div>
        <hr className={`hr ${darkmodeClass}`}/>

        <div className={`about-page-content ${darkmodeClass} ${activeSection === 'vision' ? 'active' : ''}`}>
          <h2 className={`vision ${activeSection === 'vision' ? 'active' : ''}`}>Our Vision</h2>
          <p>Pixabay is more than just a repository of images; it's a global community of artists, photographers, and creatives who contribute their work for the greater good. Our vision is to foster a world where everyone has access to beautiful visuals without any barriers.</p>
        </div>
        <hr className={`hr ${darkmodeClass}`}/>
        <div className={`about-page-content ${darkmodeClass} ${activeSection === 'community' ? 'active' : ''}`}>
          <h2 className={`community ${activeSection === 'community' ? 'active' : ''}`}>Community-Driven Content</h2>
          <p>What sets Pixabay apart is the incredible community that fuels its growth. Talented photographers and artists contribute their work with the understanding that it will be freely available for personal and commercial use. This collaborative spirit has led to a vast collection of diverse, high-resolution images that cater to a wide range of creative needs.</p>
        </div>
        <hr className={`hr ${darkmodeClass}`}/>
        <div className={`about-page-content ${darkmodeClass} ${activeSection === 'commitment' ? 'active' : ''}`}>
          <h2 className={`commitment ${activeSection === 'commitment' ? 'active' : ''}`}>Our Commitment</h2>
          <p>Pixabay is committed to providing a seamless and enjoyable experience for both contributors and users. We ensure that the platform remains user-friendly, constantly improving features to enhance the search, discovery, and download process. Your feedback is invaluable in shaping the future of Pixabay.</p>
        </div>
        <hr className={`hr ${darkmodeClass}`}/>
        <div className={`about-page-content ${darkmodeClass} ${activeSection === 'explore' ? 'active' : ''}`}>
          <h2 className={`explore ${activeSection === 'explore' ? 'active' : ''}`}>Explore, Create, Share</h2>
          <p>Pixabay offers a myriad of tools and features for users to explore, create, and share. From powerful search functionalities to curated collections, we empower you to find the perfect image for your projects. Additionally, our Pixabay Editor allows you to modify and enhance images right in your browser, making the creative process even more accessible.</p>
        </div>
        <hr className={`hr ${darkmodeClass}`}/>
        <div className={`about-page-content ${darkmodeClass} ${activeSection === 'join' ? 'active' : ''}`}>
          <h2 className={`join ${activeSection === 'join' ? 'active' : ''}`}>Join the Pixabay Community</h2>
          <p>Whether you're a seasoned photographer, a budding artist, or someone in search of captivating visuals, Pixabay welcomes you to join our vibrant community. Explore, contribute, and be part of a global movement that celebrates the beauty of free and open creativity.</p>
        </div>
        <hr className={`hr ${darkmodeClass}`}/>
        <div className={`about-page-content ${darkmodeClass} ${activeSection === 'thankyou' ? 'active' : ''}`}>
          <h2 className={`thankyou ${activeSection === 'thankyou' ? 'active' : ''}`}>Thank You for Being a Part of Pixabay</h2>
          <p>We extend our gratitude to every contributor and user who has made Pixabay what it is today. Your support drives us to continue improving and expanding our platform, making Pixabay a place where creativity knows no bounds.</p>
        </div>

      </div>
    </div>
  );
};

export default About;
